import { useContext } from "react";
import { TipContext } from "../../containers/TipContext";
import Tippy from "@tippyjs/react";
import styles from "./Augment.module.css";
const Augment = ({ augment, size = 30 }) => {
  const tips = useContext(TipContext);
  return (
    <>
      {" "}
      <Tippy
        content={
          <div
            className={
              tips.augment && tips.augment[augment] ? "" : styles.loading
            }
            dangerouslySetInnerHTML={{
              __html:
                tips.augment && tips.augment[augment]
                  ? tips.augment[augment]
                  : "Loading...",
            }}
          />
        }
        onShow={() => {
          if (!tips.showAugment) tips.setShowAugment(true);
        }}
      >
        {augment > 0 && (
          <img
            width={size}
            height={size}
            src={`https://cdn5.xdx.gg/augment${size}/${augment}.webp`}
            srcSet={`https://cdn5.xdx.gg/augment${size}/${augment}.webp ${size}w,
                   https://cdn5.xdx.gg/augment${size * 2}/${augment}.webp ${
              size * 2
            }w`}
            alt={augment}
          />
        )}
      </Tippy>
    </>
  );
};

export default Augment;
